<template>
  <div>
    <header id="tips1">
        特别提醒：本应用不提供照片存储功能，证件照自付款成功之日起 20天后会自动删除，请尽早提取或者发送到邮箱。
    </header>
    <mt-navbar v-model="photoType">
      <mt-tab-item id="digital">电子订单</mt-tab-item>
      <mt-tab-item id="print">冲印订单</mt-tab-item>
    </mt-navbar>

    <mt-tab-container v-model="photoType">
      <mt-tab-container-item id="digital">
           <!-- 有证件照 -->
        <div class="order-container" v-if="digitalOrders.length > 0">
          <!-- <div class="list-item" v-for="(item, key) in digitalOrders" :key="key">
            <div class="list-info">
              <div class="photo-container">
                <img :src="`${getPhotoBaseUrl}${item.final_pic_name}`">
              </div>
              <div class="photo-info">
                <div class="photo-name">{{item.spec_name}}</div>
                <div class="photo-sn">{{item.serial_number}}</div>
              </div>
            </div>

            <div class="list-control">
              <button class="list-control-btn" @click.stop="checkDetailDigitalOrder(item)">保存电子照</button>
            </div>
          </div> -->
					<div v-for="(item, key) in digitalOrders" :key="key">
						<div class='digital-contaier'>
							<div class='order-id-container'>
								<div class='order-id'>订单编号：{{item.serial_number}}        
								</div>
							</div>
							<div class='order-main-container'>
								<div class='info-container'>
									<div class='spec-name-container'>{{item.spec_name}}
									</div>
									<div class='time-container'>{{item.created_at}}
									</div>
								</div>
								<div v-if="Array.isArray(item.final_pic_name)">
									<img class='ele-image' :src="`${getPhotoBaseUrl}${item.final_pic_name[0]}`" />
								</div>
								<div v-else>
									<img class='ele-image' :src="`${getPhotoBaseUrl}${item.final_pic_name}`" />
								</div>
								
							</div>
							<div class='save-button-container'>
								<div @click.stop="toSave(item)" class='save-button'>
									保存电子照
								</div>
							</div>
						</div>
					</div>
        </div>
        <!-- 没有证件照 -->
        <div v-if = "isRequest && digitalOrders.length < 1" class="no-photo">
					<img src="../assets/noDigital.png" class='none-image' />
          <div class='none-text'>您当前还没有证件照哦～</div>
          <div class='none-button' @click="takePhoto">立即拍摄</div>
        </div>       
      </mt-tab-container-item>

      <mt-tab-container-item id="print">
        <div class="order-container " v-if="printOrders.length > 0">
          <!-- <div class="list-item" @click="checkDetailPrintOrder(item)" v-for="(item, key) in printOrders" :key="key">
            <div class="list-info">
              <div class="photo-container">
                <img :src="`${item.final_pic_name}`">
              </div>
              <div class="photo-info">
                <div class="photo-name">{{item.spec_name}}</div>
                <div class="photo-sn">{{item.serial_number}}</div>
              </div>
            </div>
          </div> -->
        
				<div v-for="(item, key) in printOrders" :key="key">
					<div class='digital-contaier' @click="checkDetailPrintOrder(item)">
						<div class='order-id-container'>
							<span class='order-id' >          订单编号：{{item.serial_number}}        
							</span>
							<span class='order-status'>{{item.express_status}}
							</span>
						</div>
						<div class='order-main-container'>
							<div class='info-container'>
								<div class='spec-name-container'>{{item.spec_name}}
								</div>
								<div class='time-container'>{{item.paid_at}}
								</div>
							</div>
							<img class='print-image' :src="`${item.final_pic_name}`"/>
						</div>
						<!-- a:if="{{op.order_state=='processing'||op.order_state=='shipping'||op.order_state=='completed'}}" -->
						<div class='save-button-container' >
							<div class='save-button' @click.stop="openSave(item)">
								保存电子照
							</div>
						</div>
					</div>
				</div>
				</div>
        <!-- 没有证件照 -->
        <div v-if = "isRequest && printOrders.length < 1" class="no-photo">
					<img src="../assets/noPrint.png" class='none-image' />
          <div class='none-text'>您当前还没有订单哦～</div>
          <div class='none-button' @click="takePhoto">立即拍摄</div>
        </div> 

      </mt-tab-container-item>
    </mt-tab-container>
		<mt-tabbar v-model="selected" :fixed='true'>
		  <mt-tab-item id="home">
			<img slot="icon" src="../assets/index.png">
			首页
		  </mt-tab-item>
		  <mt-tab-item id="orderList">
			<img slot="icon" src="../assets/mask.png">
			订单
		  </mt-tab-item>
		  <mt-tab-item id="customerService">
			<img slot="icon" src="../assets/order.png">
			客服
		  </mt-tab-item>
		</mt-tabbar>
		
		<mt-popup 
		v-model="saveVisible" 
		position="bottom">
			 <div class='save-container'>
				<div class='save-title'>
					保存电子照
					<div class='close-save' @click="closeSave">×</div>
				</div>
				<div class='save-ways-container'>
					<div class='save-way' @click="chooseSaveWay('extractedCode')" v-if='chosenOrder.extract_code'>
					<img src="../assets/extractedCode.png" class="save-way-icon" />
					<div class="save-way-text" :class='chosenWay=="extractedCode"?"chosen-save-way-text":""'>提取码</div>
					</div>
					<div class='save-way' @click="chooseSaveWay('email')">
					<img src="../assets/email.png" class="save-way-icon" />
					<div class="save-way-text" :class='chosenWay=="email"?"chosen-save-way-text":""'>发送到邮箱</div>
					</div>
				</div>
				<div v-show="chosenWay=='extractedCode'">
					<div class='save-tip'>
						请在“电脑浏览器”中打开网址提取证件照
					</div>
					<div class='cell'>
						<div class='cell-title'>下载地址</div>
						<div class='cell-content'>
							www.id-photo-verify.com/t
						</div>
					</div>
					<div class='cell'>
						<div class='cell-title'>提取码</div>
						<div class='cell-content'>
							{{chosenOrder.extract_code}}
						</div>
					</div>
					<div class='execute-container'>
						<div class='save-execute copy' @click="copyExtractedCode" :data-clipboard-text="`下载地址:www.id-photo-verify.com/t
提取码: ${chosenOrder.extract_code}`">复制地址及提取码</div>
					</div>
				</div>
				<div v-show="chosenWay=='email'">
					<div class='save-tip'>
						请在以下输入框中输入您的邮箱，每单最多可以发送3次
					</div>
					<div class='cell'>
						<div class='cell-title'>电子邮箱</div>
						<div class='cell-content' @click="enterEmail">
						{{Email?Email:"请输入您的电子邮箱"}}
						</div>
					</div>
					<div class='execute-container'>
						<div class='save-execute' @click="sendEmail">发送至指定邮箱</div>
					</div>
				</div>
			</div>
		</mt-popup>

  </div>
</template>

<script>
import { checkOrderLists,checkPrintOrderLists,sendEMailEle,sendEMailPrint } from "@/data/api";
import { config } from "@/config/config";
import { mapMutations, mapActions } from "vuex";
import Clipboard from 'clipboard';
export default {
  data() {
    return {
      digitalOrders: [],
      printOrders: [],
      openId: null,
      getPhotoBaseUrl: null,
      photoType: "digital",
      isRequest: false,
			selected:'orderList',
			saveVisible:false,
			chosenOrder:{},
			chosenWay:'extractedCode',
			Email:''
    };
  },
  created: function() {
    ap.setNavigationBar({
      title: "我的证件照"
    });
		this.$ba.trackPageview('/orderList');
    this.getPhotoBaseUrl = config.getPhotoBaseUrl;
    const { openId,photoType } = this.$route.query;
		if(photoType){
			this.photoType=photoType;
		}
    //fetch data from server
    let openId_tmp = openId || localStorage.openId;
    this.getPrice();
    ap.showLoading();
    checkOrderLists(openId_tmp)
      .then(({ data }) => {
				console.log(data)
        const { result } = data;
        const digitalOrders = result.filter(item => item.is_print === 0);
        const printOrders = result.filter(item => item.is_print === 1);
        for(let x=0;x<printOrders.length;x++){
	        	printOrders[x].final_pic_name=this.getPhotoBaseUrl+printOrders[x].final_pic_name;
	        	if(printOrders[x].express_info.status===1){
	        		printOrders[x].express_info.status='已发货';
	        	}else{
	        		printOrders[x].express_info.status='未发货';
	        	}
	        }
        this.digitalOrders = digitalOrders;
        this.printOrders = printOrders;
        this.isRequest = true;
      })
      .catch(err => {
        ap.showToast({
          content: err
        });
      })
      .then(() => {
      	
      	checkPrintOrderLists(openId_tmp)
      	.then(({ data }) => {
      		console.log(data)
	      	if(data.result instanceof Array){
		        const newPrintOrders = data.result.filter(item => item.paid_at != null);
		        if(newPrintOrders.length>0){
		        	for(let x=0;x<newPrintOrders.length;x++){
		        	newPrintOrders[x].spec_name=newPrintOrders[x].description;
		        	newPrintOrders[x].serial_number=newPrintOrders[x].order_no;
		        	newPrintOrders[x].final_pic_name=newPrintOrders[x].image_urls.print;
		        	newPrintOrders[x].photoUrl=newPrintOrders[x].image_urls.single;
		        	newPrintOrders[x].print_number=newPrintOrders[x].quantity;
							let paidDate=new Date(newPrintOrders[x].paid_at);
		        	newPrintOrders[x].paid_at=paidDate.getFullYear()+'-'+(paidDate.getMonth()+1)+'-'+paidDate.getDate()+' '+paidDate.toTimeString().substring(0,8);
							
		        	newPrintOrders[x].express_info={};
		        	newPrintOrders[x].express_info.addr=newPrintOrders[x].user_address;
		        	newPrintOrders[x].express_info.name=newPrintOrders[x].user_name;
		        	newPrintOrders[x].express_info.phone=newPrintOrders[x].user_phone;
		        	newPrintOrders[x].express_info.company=newPrintOrders[x].express_service;
		        	newPrintOrders[x].express_info.number=newPrintOrders[x].express_no;
		        	newPrintOrders[x].express_info.status=this.formatState(newPrintOrders[x].state);
		        	}
		        	this.printOrders = this.printOrders.concat(newPrintOrders);
		        }
	       	}
	        ap.hideLoading();
	      })
	      	.catch(err => {
	        ap.showToast({
	          content: err
	        });
	      })
       
        
      });
  },
	mounted(){
		var copybtn = document.getElementsByClassName('copy')
    this.clipboard = new Clipboard(copybtn);
	},
  methods: {
    ...mapMutations([
      "RECORD_SPECINFO",
      "RECORD_SELECTED_BG",
      "RECORD_ORDERINFO"
    ]),
    ...mapActions(["getPrice"]),
    openSave(e){
			this.chosenOrder=e;
			this.saveVisible=true;
			if(!this.chosenOrder.extract_code){
				this.chosenWay='email'
			}
			console.log(e);
		},
		toSave(e){
			 this.$router.push({
			  name: "savePhoto",
			  query: {
			  	orderInfo:e
			  }
			});
		},
		closeSave(){
			this.saveVisible=false;
		},
		chooseSaveWay(e){
			this.chosenWay=e
		},
		enterEmail(){
				let Email=prompt("请输入您的邮箱");
				if(Email){
					this.Email=Email;
				}
		},
		sendEmail(){
			let openId_tmp = this.openId || localStorage.openId;
				let re = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
				if (re.test(this.Email)) {
					if(this.chosenOrder.id){//有id是冲印订单
						console.log(this.Email,this.chosenOrder.id,openId_tmp)
						sendEMailPrint(this.Email,this.chosenOrder.id,openId_tmp).then(( res ) => {
							console.log(res)
							if(res.data.code==200){
								ap.showToast({
									content: `发送成功!剩余发送次数${res.data.remaining_time}`
								});
							}else if(res.data.code==400){
								ap.showToast({
									content: res.data.mes
								});
							}else{
								ap.showToast({
									content: "发送失败，订单未支付或已过期！"
								})
							}
						})
						.catch(err => {
						  console.log(err)
						})
					}else{
						sendEMailEle(this.Email,this.chosenOrder.go_print.order_id,openId_tmp).then(( res ) => {
							console.log(res)
							if(res.data.code==200){
								ap.showToast({
									content: `发送成功!剩余发送次数${res.data.remaining_time}`
								});
							}else if(res.data.code==400){
								ap.showToast({
									content: res.data.mes
								});
							}else{
								ap.showToast({
									content: "发送失败，订单未支付或已过期！"
								})
							}
						})
						.catch(err => {
						  console.log(err)
						})
					}
				}else{
					ap.showToast({
						content: '请输入有效的邮箱地址！'
					});
				}
		},
    takePhoto() {
      this.$router.push({ name: "home" });
    },
		copyExtractedCode(){
			this.clipboard.on('success', function (e) {
				console.log(e);
				alert("复制成功！")
			})
			this.clipboard.on('error', function (e) {
				console.log(e);
				alert("复制失败！请尝试长按文字复制！")
			});
		},
    checkDetailPrintOrder(item) {
      const {
      	final_pic_name,
      	photoUrl,
        serial_number,
        print_number,
				delivery,
				paid_at,
				price_total,
        express_info: { addr, company, name, number, phone, status }
      } = item;
      this.$router.push({
        name: "detailPrintOrder",
        query: {
        	final_pic_name:final_pic_name,
        	photoUrl:photoUrl,
          expressStatus: status,
          expressCompany: company,
          consigneePhone: phone,
          consigneeName: name,
          consigneeAddr: addr,
          expressNumber: number,
          serialNum: serial_number,
          printQty: print_number,
					delivery:delivery,
					paid_at:paid_at,
					price_total:price_total
        }
      });
    },
    formatState(state) {
      if (state == "processing") {
        return "待发货"
      } else if (state == 'shipping') {
        return "已发货"
      } else if (state == "completed") {
        return "已签收"
      } else if (state == "refunded") {
        return "已退款"
      } else if (state == "refunding") {
        return "待退款"
      } else {
        return null
      }
  },
  },
	watch:{
		selected:function(val,oldVal){
				switch(val){
						case 'home':
								this.$router.replace('/');
						break;
						case 'orderList':
								this.$router.replace({ name: "orderList", query: { openId: this.openId } });
						break;
						case 'customerService':
								this.$router.replace('/customerService');
						break;
				}
		}
	},
  computed: {}
};
</script>

<style lang="scss" scoped>
#tips1 {
  width: 100%;
  background: rgba(255, 250, 245, 1);
  font-size: 12px;
  color: #ff9e0d;
  padding: 4.3986vw 3.2vw;
}
.no-photo {
	margin: auto;
  position: relative;
  text-align: center;
}

.order-container{
  background:rgba(247,247,247,1);
  padding: 10px 10px 50px 10px;
}
.digital-contaier{
  width: 94.667vw;
  background:rgba(255,255,255,1);
  border-radius:4px;
  margin-bottom: 10px;
}
.order-id-container{
  height: 50px;
  line-height: 50px;
  font-size:12px;
  padding-left: 4vw;
  padding-right: 4vw;
}
.order-id{
  color:rgba(153,153,153,1);
  width: 80%;
}
.order-status{
  color: #F5A623;
  float: right;
}
.ele-image{
  margin-left: 60px;
	width:21.333vw;
	height: 29vw;
}
.print-image{
  width: 34.6667vw;
	height: 23.112vw;
  margin-left: 2.667vw;
}
.info-container{
  width: 49.333vw;
  display: inline-block;
  align-self: center;
  
}
.order-main-container{
  padding: 7px 4vw;
  display: flex;
}
.spec-name-container{
  font-size:17px;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 12px;
}
.time-container{
  font-size:13px;
  line-height:18px;
  color:rgba(153,153,153,1);
}
.save-button-container{
  padding: 10px 4vw 10px 0;
  height: 47.5px;
}
.save-button{
  width:22.4vw;
  height:27.5px;
  border-radius:15px;
  border:1px solid rgba(198,198,198,1);
  font-size:13px;
  color:rgba(153,153,153,1);
  line-height:27.5px;
  text-align: center;
  float: right;
}
.save-container{
  height: auto;
  background: #ffffff;
	width: 100vw;
}
.save-title{
  font-size:12px;
  color:rgba(102,102,102,1);
  height: 49px;
  padding-top: 20px;
  padding-bottom: 12px;
  text-align: center;
  position: relative;
}
.close-save{
  position: absolute;
  height: 0.32rem;
  line-height: 0.32rem;
  color: rgba(191,191,191,1);
  font-size: 32px;
  top: 10px;
  right: 10px;
}
.save-ways-container{
  width: 100%;
  height: 100px;
  display: flex;
}
.save-way{
  height: 100px;
  width: 33.33vw;
  margin: auto;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.save-way-icon{
  width: 50px;
  height: 50px;
}
.save-way-text{
  margin-top: 5px;
  font-size:12px;
  color:rgba(153,153,153,1); 
}
.chosen-save-way-text{
  color:rgba(245,166,35,1);
}
.save-tip{
  text-align: center;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size:13px;
  color:rgba(245,166,35,1);
  margin-top: 10px;
  margin-bottom: 6px;
  background:rgba(255,249,240,1);
}
.execute-container{
  width: 100vw;
  height: 60px;
  margin-top: 15px;
  background:rgba(255,255,255,1);
  box-shadow:0px 0px 16px 0px rgba(211,211,211,0.5);
  padding:10px 8px;
}
.save-execute{
  width:94.667vw;
  height:45px;
  background:rgba(68,128,231,1);
  box-shadow:0px 5px 10px 0px rgba(68,128,231,0.25);
  border-radius:22.5px;
  line-height:45px;
  color: white;
  font-size: 16px;
  text-align: center;
}
.placeholder{
  color: #999999;
  font-size: 13px;
  text-align: right;
}
.list-control {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 12.2667vw;
  .list-control-btn {
    font-size: 2.9333vw;
    width: 18.9333vw;
    height: 5.6vw;
    border-radius: 5px;
    margin-right: 3.333vw;
    background: none;
    color: #5f5f5f;
    border: 1px solid #8b8b8b;
    outline: none;
  }
  .color-btn {
    color: #6e41fe;
    border: 1px solid #6e41fe;
  }
}
.mint-navbar .mint-tab-item.is-selected{
	border-bottom: 3px solid rgba(68,128,231,1) !important;
	color: rgba(68,128,231,1) !important ;
	margin-bottom: 0 !important;
}
.mint-tab-container{
		overflow: visible !important;
}
.none-button{
	position: absolute;
  top: 240px;
  left:calc(50% - 80px);
	// margin: 0 auto;
  width: 160px;
  height: 45px;
  line-height:49.5px;
  background:rgba(68,128,231,1);
  box-shadow:0px 10px 20px 0px rgba(68,128,231,0.25);
  border-radius:22.5px;
  font-size:16px;
  color:rgba(255,255,255,1);  
}
.none-image{
  width: 89.333vw;
  height: 69.333vw;
}
.none-text{
  position: absolute;
  top: 200px;
  font-size:13px;
  color:rgba(153,153,153,1);
  width: 100%;
  text-align: center;
}
</style>
